import * as React from "react";
import Dropzone from "react-dropzone";
import {LoadableProps} from "../common/props/LoadableProps";
import FormButtonsView from "../ui/form/FormButtonsView";
import ButtonTertiary from "../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {OnSuccess} from "../../store/action/actionHelpers";
import {Option} from "ts-option";
import Spinner from "../../hiberUiKit/src/atoms/Spinner/Spinner";

const spinner = require("./../../../resources/hiber/img/spinner-orange.png");

interface ComponentProps {
	/**
	 * Upload button click action
	 * @param {File} files File to upload
	 * @param {(file: File) => void} onFileReject on fail upload file callback
	 * @param {OnSuccess} onSuccess on success upload all files
	 */
	onUpload: (files: File, onSuccess: OnSuccess) => void;
	/**
	 * Validate after file selection
	 * @param {File} file
	 */
	onDropValidate?: (file: File) => void;
	/**
	 * On cancel callback
	 */
	onCancel: () => void
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
	/**
	 * Received error descriptions.
	 */
	errors: Option<string[]>;
	/**
	 * Indicates if upload button is disabled
	 */
	isUploadButtonDisabled?: boolean;
	/**
	 * Acceptable file types (default: .xls,.xlsx)
	 */
	accept?: string;
}

interface State {
	/**
	 * Uploaded file.
	 */
	acceptedFile: File;
}

type Props = ComponentProps & LoadableProps;

export default class SingleFileSelector extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {acceptedFile: null};
		this.onDrop = this.onDrop.bind(this);
		this.clearFiles = this.clearFiles.bind(this);
		this.displayErrors = this.displayErrors.bind(this);
	}

	render() {
		const hasErrors = this.props.errors.getOrElse([]).length > 0;
		const acceptedFileTypes = this.props.accept || ".xls,.xlsx";
		return (
			<div className={'c-single-file-selector'}>
				<Dropzone onDrop={this.onDrop}
						  accept={acceptedFileTypes}
						  className={"dropzone"}
						  multiple={false}
						  activeClassName={"active"}>
					<div className={"t-link"}>Click here to select file to upload or simply drop it in.</div>
					{this.props.loading && <Spinner size={36} imgUrl={spinner}/>}
				</Dropzone>
				{this.renderAcceptedFiles()}
				{this.displayErrors()}
				<FormButtonsView align={"right"}>
					<ButtonTertiary label="Cancel"
									onClick={() => {
										this.props.onCancel();
										this.clearFiles()
									}}
									disabled={this.props.filesUploading}/>
					<ButtonPrimary label={"Upload"}
								   onClick={() => this.props.onUpload(this.state.acceptedFile,
									   this.clearFiles)}
								   disabled={this.state.acceptedFile == null || this.props.filesUploading ||
								   this.props.isUploadButtonDisabled || hasErrors}/>
				</FormButtonsView>
			</div>
		)
	}

	displayErrors() {
		return (
			!!this.props.errors.getOrElse([]).length &&
			<div className={'error-list'}>
				<h4>Upload errors</h4>
				{this.props.errors.map(
					errors => errors.map((e, index) => (<span key={index} className="d-block">{e}</span>))).orNull}
			</div>
		)
	}

	renderAcceptedFiles() {
		return (
			this.state.acceptedFile &&
			<div>
				<h4>File selected</h4>
				<div>{this.state.acceptedFile.name}</div>
			</div>
		)
	}

	onDrop(acceptedFiles: File[]) {
		const [acceptedFile] = acceptedFiles;
		this.setState({acceptedFile})
		if (acceptedFile && this.props.onDropValidate) {
			this.props.onDropValidate(acceptedFile);
		}

	}

	clearFiles() {
		this.setState({acceptedFile: null});
	}
}